import React, { Fragment, Suspense } from 'react';
// import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { LinearProgress } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  content: {
    height: '100%',
    paddingTop: 56,
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64
    }
  }
}));

const SinglePage = props => {
  // const { route } = props;
  const { children } = props;

  const classes = useStyles();

  return (
    <Fragment>
      <main className={classes.content}>
        <Suspense fallback={<LinearProgress />}>
          { children }
          {/* {renderRoutes(route.routes)} */}
        </Suspense>
      </main>
    </Fragment>
  );
};

SinglePage.propTypes = {
  route: PropTypes.object
};

export default SinglePage;
